module.exports = __webpack_public_path__ + "static/img/5.cdf8992.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/7/3/eng/5.png
// module id = T9+H
// module chunks = 0